import { render, staticRenderFns } from "./WorkTextEditorImageUploadArea.vue?vue&type=template&id=4d4860e5&scoped=true"
import script from "./WorkTextEditorImageUploadArea.vue?vue&type=script&lang=js"
export * from "./WorkTextEditorImageUploadArea.vue?vue&type=script&lang=js"
import style0 from "./WorkTextEditorImageUploadArea.vue?vue&type=style&index=0&id=4d4860e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4860e5",
  null
  
)

export default component.exports